import Axios from "../utils/axios-utils";

// get all jobs minimals
export const getJobsMinimal = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/jobs/minimal`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Jobs  error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Jobs failed" }
        };
    }
};

// get all jobs listg
export const getAllJobs = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/jobs`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Jobs  error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Jobs failed" }
        };
    }
};


//  Get Job
export const getJob = async (accountId, jobId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/jobs/${jobId}`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Job error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get Job failed" }
        };
    }
};

// create Job
export const createJob = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/jobs`, {
            type: data.type,
            name: data.name,
            location: data.location,
            address: data.address,
            city: data.city,
            state: data.state,
            country: data.country,
            postalCode: data.postalCode,
            startTime: data.startTime,
            endTime: data.endTime,
            note: data.note,
            attributes: {
                priority: data.priority,
                assignedTo: data.assignedTo
            },
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create JOB error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create JOB failed" }
        };
    }
};

// delete jOB
export const deleteJob = async (accountId, jobId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/jobs/${jobId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete job error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete job failed" },
            status: error.response?.status || 500
        };
    }
};

// update Job
export const updateJob = async (accountId, jobId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/jobs/${jobId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Job error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Job failed" }
        };
    }
};

// get job statuses
export const getJobStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/jobs/statuses`);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Getting job statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Getting job statuses failed" }
        };
    }
};

// update job status
export const updateJobStatus = async (accountId, jobId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/jobs/${jobId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update job Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update job Status failed" }
        };
    }
};

// get all jobs notes
export const getAllJobNotes = async (accountId, jobId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/jobs/${jobId}/notes`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Job notes  error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Job notes failed" }
        };
    }
};

// get all jobs expenses
export const getAllJobExpenses = async (accountId, jobId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/jobs/${jobId}/expenses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Job expenses  error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Job expenses failed" }
        };
    }
};

// get all jobs users
export const getAllJobUsers = async (accountId, jobId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/jobs/${jobId}/users`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Job users  error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Job users failed" }
        };
    }
};


// Assing JOB to User 
export const assignUserJob = async (accountId, jobId, userId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/jobs/${jobId}/users/${userId}`);

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Assing JOB to User error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Assing JOB to User failed" }
        };
    }
};

// Assing JOB to User 
export const unAssignUserJob = async (accountId, jobId, userId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/jobs/${jobId}/users/${userId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Un Assinged User error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Un Assinged User failed" },
            status: error.response?.status || 500
        };
    }
};